export const comfortRoomDetails =
    [
        {
            roomType: "Comfort",
            title: "About the room",
            images: [
                { source: "/assets/comfortPlus/img1.webp" },
                { source: "/assets/comfortPlus/img2.webp" },
                { source: "/assets/comfortPlus/img3.webp" },
                { source: "/assets/comfortPlus/img4.webp" },
                { source: "/assets/comfortPlus/img5.webp" },
                { source: "/assets/comfortPlus/img6.webp" },
                { source: "/assets/comfortPlus/img7.webp" },
            ],
            roomVideo: "/assets/comfortRoomVideo.mp4"
        }
    ]

export const comfortPlusRoomDetails =
    [
        {
            roomType: "Comfort Plus",
            title: "About the room",
            images: [
                { source: "/assets/comfortPlus/img1.webp" },
                { source: "/assets/comfortPlus/img2.webp" },
                { source: "/assets/comfortPlus/img3.webp" },
                { source: "/assets/comfortPlus/img4.webp" },
                { source: "/assets/comfortPlus/img5.webp" },
                { source: "/assets/comfortPlus/img6.webp" },
                { source: "/assets/comfortPlus/img7.webp" },
            ],
            roomVideo: "/assets/comfortPlusRoomVideo.mp4"
        }
    ]

export const duplexRoomDetails =
    [
        {
            roomType: "Duplex",
            title: "About the room",
            images: [
                { source: "/assets/duplex/img6.webp" },
                { source: "/assets/duplex/img1.webp" },
                { source: "/assets/duplex/img2.webp" },
                { source: "/assets/duplex/img3.webp" },
                { source: "/assets/duplex/img4.webp" },
                { source: "/assets/duplex/img5.webp" },
                { source: "/assets/duplex/img7.webp" },
            ],
            roomVideo: "/assets/DuplexRoomVideo.mp4"
        }
    ]